import React from 'react';
import {useTranslation} from 'react-i18next';

import {COMPANY_NAME_SHORT} from '@br/mg-components';

import useStyle from './styles';

const Footer = () => {
    const {t} = useTranslation(['footer']);
    const style = useStyle();
    return (
        <p
            className={style.text}
            data-testid="Footer"
        >
            {t('footer:copyright', '© {{year}} {{companyName}}', {
                year: new Date().getFullYear(),
                companyName: COMPANY_NAME_SHORT,
            })}
        </p>
    );
};

export default Footer;
